import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { MEDIA_KIT_PDF, NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import Button from 'src/common/components/ButtonDS22';

const DownloadMediaKit: FC = () => {
  const [t] = useTranslation('common');

  return (
    <Button
      href={MEDIA_KIT_PDF}
      type="link"
      fitWidth="m"
      {...NEW_TAB_ATTRIBUTES}
    >
      {t('download-media-kit')}
    </Button>
  );
};

export default DownloadMediaKit;
